import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAgencySettingsMutationVariables = Types.Exact<{
  input: Types.UpdateAgencySettingsInput;
}>;


export type UpdateAgencySettingsMutation = { __typename?: 'Mutation', UpdateAgencySettings: { __typename?: 'UpdateAgencySettingsPayload', agencySettingsPayload?: { __typename?: 'AgencySettingsPayload', id?: any | null, name?: string | null, etaInterval?: number | null } | null, errors?: Array<{ __typename?: 'InternalServerUserError', message: string, code: 'InternalServerUserError' } | { __typename?: 'UnknownAgencyUserError', message: string, agencyId: any, code: 'UnknownAgencyUserError' } | { __typename?: 'UserError', message: string, code: 'UserError' } | { __typename?: 'ValidationUserError', message: string, code: 'ValidationUserError' }> | null } };


export const UpdateAgencySettingsDocument = gql`
    mutation UpdateAgencySettings($input: UpdateAgencySettingsInput!) {
  UpdateAgencySettings(input: $input) {
    agencySettingsPayload {
      id
      name
      etaInterval
    }
    errors {
      code: __typename
      ... on Error {
        message
      }
      ... on UnknownAgencyUserError {
        agencyId
      }
    }
  }
}
    `;
export type UpdateAgencySettingsMutationFn = Apollo.MutationFunction<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>;

/**
 * __useUpdateAgencySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAgencySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencySettingsMutation, { data, loading, error }] = useUpdateAgencySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>(UpdateAgencySettingsDocument, options);
      }
export type UpdateAgencySettingsMutationHookResult = ReturnType<typeof useUpdateAgencySettingsMutation>;
export type UpdateAgencySettingsMutationResult = Apollo.MutationResult<UpdateAgencySettingsMutation>;
export type UpdateAgencySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAgencySettingsMutation, UpdateAgencySettingsMutationVariables>;